import { GridEventListener } from "@mui/x-data-grid-pro"
import { useTableContext } from "../provider"

export const useRowHandler = () => {

  const ctx  = useTableContext()
  const { rowClickHandler } = ctx.props

  const onRowClick: GridEventListener<"rowClick"> = (params, event, details) => {
    if (!event || !event.target) return
    const target = event.target as any
    if (target.tagName === "INPUT" || target.type === "checkbox") return

    if (rowClickHandler) rowClickHandler(params, event, details)
  }

  return {
    onRowClick,
  }
}